import { AERIALS_LIST_TAG } from '@/api/constants';
import { api } from '@/api/core/api';
import { handleQueryLifecycle } from '../utils';
import type { AerialMutationPayload, AerialMutationResponse } from './types';

export const EDIT_AERIAL_URL = 'aerial/edit';

/** A partial update: the BE keeps the saved value of every field left out. */
export type EditAerialPayload = Partial<AerialMutationPayload> & { aerialId: string };
export type EditAerialResponse = AerialMutationResponse;

const editAerialApi = api.injectEndpoints({
  endpoints: (builder) => ({
    postEditAerial: builder.mutation<EditAerialResponse, EditAerialPayload>({
      query: (body) => ({
        url: EDIT_AERIAL_URL,
        method: 'POST',
        body,
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await handleQueryLifecycle(queryFulfilled, () => {
          dispatch(api.util.invalidateTags([AERIALS_LIST_TAG]));
        });
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { usePostEditAerialMutation } = editAerialApi;
